import { FC } from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import Skeleton from '@/entities/Skeleton/Skeleton';

interface Props extends VariantProps<typeof cvaGridEmpty> {}

const ImagesLoading: FC<Props> = ({ firstRowSize = 'default' }) => {
  return (
    <div className={cvaGridEmpty({ firstRowSize })}>
      <Skeleton className={cvaEmptyItem()} intent={'outline'} />
      <Skeleton className={cvaEmptyItem()} intent={'outline'} />
      <Skeleton className={cvaEmptyItem()} intent={'outline'} />
      <Skeleton className={cvaEmptyItem()} intent={'outline'} />
      <Skeleton className={cvaEmptyItem()} intent={'outline'} />
      <Skeleton className={cvaEmptyItem()} intent={'outline'} />
      <Skeleton className={cvaEmptyItem()} intent={'outline'} />
    </div>
  );
};

const cvaGridEmpty = cva(
  [
    'ImagesLoading-cvaGridEmpty',
    'grid grid-cols-12 w-full',
    'md-max:grid-cols-2 md-max:gap-0.8 sm-max:grid-cols-1',
  ],
  {
    variants: {
      firstRowSize: {
        default:
          'auto-rows-[44rem] gap-1.6 md-max:auto-rows-[42rem] md-max:gap-1.2 sm-max:auto-rows-[36rem]',
        min: 'grid-rows-[44rem] auto-rows-[32rem] gap-1.6 md-max:grid-rows-[30.4rem] md-max:gap-1.2 sm-max:auto-rows-[24rem] sm-max:grid-rows-[24rem]',
      },
    },
  }
);

const cvaEmptyItem = cva([
  'ImagesLoading-cvaEmptyItem',
  'col-span-3 child-1:col-span-4 child-2:col-span-4 child-3:col-span-4 md-max:!col-span-1',
  'md-max:child-5:hidden md-max:child-6:hidden md-max:child-7:hidden',
  'sm-max:hidden sm-max:child-1:block sm-max:child-2:block ',
]);

export default ImagesLoading;
